import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";

/** USD price per 1 GEMS from `users/gems-price`. */
export async function fetchGemsPriceUsd() {
  const res = await axios.get(`${API_URL}users/gems-price`);
  const px = Number(res?.data?.data);
  return Number.isFinite(px) && px > 0 ? px : 0;
}
